// libs
import { styled } from '@nykaa/ui-components';

// constants
import { BREAKPOINTS } from 'shared/styles/base';

export const Container = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing.spacing80};
  display: flex;
  justify-content: start;
  flex-wrap: wrap;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding-bottom: ${({ theme }) => theme.spacing.spacing100};
    padding-left: ${({ theme }) => theme.spacing.spacing120};
    margin-left: ${({ theme }) => theme.spacing.spacing100};
  }
`;

export const Attribute = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 50%;
  padding-top: ${({ theme }) => theme.spacing.spacing80};
  color: ${({ theme }) => theme.colors.textSecondary};
  ${({ theme }) => theme.typography.bodySmall};

  :nth-of-type(even) {
    padding-left: ${({ theme }) => theme.spacing.spacing100};
  }

  :nth-of-type(odd) {
    padding-right: ${({ theme }) => theme.spacing.spacing100};
    border-right: 1px solid ${({ theme }) => theme.colors.textOutline};
  }

  :nth-child(-n + 2) {
    padding-top: 0;
  }

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding-top: ${({ theme }) => theme.spacing.spacing100};
  }
`;

export const AttributeLabel = styled.p`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-bottom: ${({ theme }) => theme.spacing.spacing10};
  margin-top: 0;
  ${({ theme }) => theme.typography.bodySmall};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.bodyMedium};
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`;

export const AttributeValue = styled.p`
  margin: 0;
  padding: 0;
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.bodyMedium};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.bodyLarge};
  }
`;
